(() => {
  const productContent = document.querySelector(".product__content");
  if (!productContent) return;

  const handleResize = () => {
    productContent.classList.toggle(
      "is-static",
      productContent.getBoundingClientRect().height > window.innerHeight
    );
  };

  handleResize();

  window.addEventListener("resize", handleResize, { passive: true });
})();
